export const name = "banner_top";



// WEBPACK FOOTER //
// ./src/modules/banner_top/constants.js